import React from "react";
import Context from "../../../../context";
import {
  CustomView,
  CustomModal,
  CustomButton2,
  UserInformation,
} from "../../../../components";

import "./index.sass";
import { useTranslation } from "react-i18next";

const Reject = () => {
  const { showModal, setShowModal, isLoading, selectedSchool, rejectFunction } =
    React.useContext(Context.SchoolScreen);

  const { t } = useTranslation();
  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="school-reject-modal-container">
      <CustomModal
        onClose={() => setShowModal("NONE")}
        open={showModal === "REJECT"}
      >
        <CustomView.Container className="reject-form-content">
          <CustomView.Row className="user-information-container">
            <CustomView.Column>
              <UserInformation
                name={selectedSchool?.name}
                avatar={selectedSchool?.avatar}
                isBlock={!selectedSchool?.approved}
                phoneNumber={selectedSchool?.telephone}
              />
            </CustomView.Column>
          </CustomView.Row>
          <CustomView.Row className="form-row">
            <CustomView.Column
              large={3}
              medium={4}
              small={6}
              className="form-colum"
            >
              <CustomButton2
                isLoading={isLoading}
                onClick={() => setShowModal("NONE")}
                title={t("cancel")}
              />
            </CustomView.Column>
            <CustomView.Column
              large={3}
              medium={4}
              small={6}
              className="form-colum"
            >
              <CustomButton2
                type="danger"
                title={t("disApprove")}
                onClick={() => rejectFunction(selectedSchool?._id)}
                isLoading={isLoading}
              />
            </CustomView.Column>
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default Reject;
